import { render, staticRenderFns } from "./cheap-fuel.vue?vue&type=template&id=52c014b4"
import script from "./cheap-fuel.vue?vue&type=script&lang=js"
export * from "./cheap-fuel.vue?vue&type=script&lang=js"
import style0 from "./cheap-fuel.vue?vue&type=style&index=0&id=52c014b4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports